export const LABOR_ERRORS = {
  TIME_OVERLAP: 'LABOR_TIME_OVERLAP',
} as const;

export type LaborErrorCode = (typeof LABOR_ERRORS)[keyof typeof LABOR_ERRORS];
